import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { List, ListItem, ListItemIcon, ListItemText, Collapse, Icon, Tooltip } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import { handleMenuTree } from '../../store/actions/menu'

const MenuTree = props => {
    const { handleMenuTree, menuTreeOpen, id, titlePrimary, leftIcon, children, classes } = props
    const open = id === menuTreeOpen

    return (
        <>
            <ListItem 
                button 
                onClick={_ => handleMenuTree(id)}
                className={open ? classes?.activeItem : classes?.inactiveItem}
                aria-label={`${titlePrimary} - ${open ? "Recolher" : "Expandir"}`}
                aria-expanded={open}
            >
                <ListItemIcon>
                    <Tooltip title={titlePrimary} placement="right">
                        <Icon>{leftIcon}</Icon>
                    </Tooltip>
                </ListItemIcon>
                <ListItemText primary={titlePrimary} />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {children}
                </List>
            </Collapse>
        </>
    )
}

const mapStateToProps = state => ({ menuTreeOpen: state.menu.menuTreeOpen })
const mapDispatchToProps = dispatch => bindActionCreators({ handleMenuTree }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(MenuTree)